import CoreComponent from '../../../core/CoreComponent.vue';
import AccessibilityHelper from '../../../../../helpers/accessibility-helper';
export default {
  extends: CoreComponent,
  mounted() {
    AccessibilityHelper.generateAriaLabelForBannerButton(this.cmpEl, "._awardsCertificationBanner__content__title", "._awardsCertificationBanner__content__button a");
  }
};